import SearchField from './Filters/SearchField'
import FilterPills from './Filters/FilterPills'
import AddFilterButton from './Filters/AddFilterButton'
import ViewToggleButton from './Filters/ViewToggleButton'

export default function Filters() {

  return (
    <div className='filters-container'>
      <div className='main-row'>
        <SearchField />
        <AddFilterButton />
        <ViewToggleButton />
      </div>
      <FilterPills />
    </div>
  )
}
